import { render, staticRenderFns } from "./PachymetryView.vue?vue&type=template&id=2d64baa0"
import script from "./PachymetryView.vue?vue&type=script&lang=js"
export * from "./PachymetryView.vue?vue&type=script&lang=js"
import style0 from "./PachymetryView.vue?vue&type=style&index=0&id=2d64baa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports